<svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32.6845" height="2.01588" rx="1.00794" transform="matrix(0.694162 0.719819 -0.706617 0.707597 2.50195 0)" fill="#FE8324"/>
    <rect width="32.6792" height="2.01616" rx="1.00808" transform="matrix(0.700415 -0.713736 0.700415 0.713736 0.19043 23.561)" fill="#FE8324"/>
</svg>
    